module.exports = new __parcel__URL__("cornershop-shopper-welcome.2b479668.png").toString();